import { useState } from 'react'
import { ReleaseHistory } from '@/components/releases/ReleaseHistory'
import { LINKS } from '@/lib/links'
import { openOfficialServer } from '@/lib/official'
import { useAppStore } from '@/store/app'
import layer from './SettingsLayer.module.css'
import styles from './HelpSection.module.css'

type Row = { title: string; text: string; label: string } & ({ href: string } | { official: true } | { releases: true })

const ROWS: Row[] = [
  // единственное место здесь, куда не нужно уходить из Кличата: сервер открывается внутри
  { title: 'Официальный сервер', text: 'Команда Кличата отвечает в чате и в голосовом канале. Новости выходят там же.', official: true, label: 'Открыть сервер' },
  { title: 'Что нового', text: 'Все выпуски по датам: что появилось в Кличате и что поменялось.', releases: true, label: 'Открыть' },
  { title: 'Поддержка в Telegram', text: 'Живой человек, отвечает в рабочее время. Вход, перенос сервера, ошибки — сюда.', href: LINKS.support, label: '@klichat_support' },
  { title: 'Канал с новостями', text: 'Что нового в Кличате, инструкции и планы. Вопросы под постами тоже читаем.', href: LINKS.telegramChannel, label: '@klichating' },
  { title: 'Почта', text: 'Если Telegram не подходит — напишите письмом, ответим с этого же адреса.', href: 'mailto:' + LINKS.supportEmail, label: LINKS.supportEmail },
  { title: 'Уязвимости', text: 'Нашли дыру в безопасности — напишите сюда, а не в общий чат. Ответим и поблагодарим.', href: 'mailto:' + LINKS.securityEmail, label: LINKS.securityEmail },
  { title: 'Документация API', text: 'Для тех, кто пишет ботов: адреса, события, права, совместимость с discord.js и discord.py.', href: LINKS.docs, label: 'klichat.ru/docs' },
]

/** Куда писать и что нового: официальный сервер, выпуски, поддержка, канал, почта, уязвимости, документация. */
export function HelpSection() {
  const closeSettings = useAppStore((s) => s.closeSettings)
  const [history, setHistory] = useState(false)
  return (
    <div>
      <h1 className={layer.sectionTitle}>Поддержка и новости</h1>
      <p className={layer.text}>Быстрее всего отвечаем в Telegram. В письме или сообщении назовите свой ник — так найдём учётную запись без лишних вопросов.</p>
      <ul className={styles.list}>
        {ROWS.map((r) => (
          <li key={r.title} className={styles.row}>
            <div className={styles.body}>
              <h3 className={styles.title}>{r.title}</h3>
              <p className={styles.text}>{r.text}</p>
            </div>
            {'official' in r ? (
              <button type="button" className={styles.link} onClick={() => { closeSettings(); void openOfficialServer() }}>{r.label}</button>
            ) : 'releases' in r ? (
              <button type="button" className={styles.link} onClick={() => setHistory(true)}>{r.label}</button>
            ) : (
              <a className={styles.link} href={r.href} target="_blank" rel="noopener">{r.label}</a>
            )}
          </li>
        ))}
      </ul>
      {history ? <ReleaseHistory onClose={() => setHistory(false)} /> : null}
    </div>
  )
}
